import {
  getFilePathDisplayLabel,
  getVirtualPathDetails,
} from '@kirin/api-client/contracts';

// Display-only forward-slash conversion (backend data untouched).
export function normalizePathForDisplay(path: string): string {
  return path.replace(/\\/g, '/');
}

/**
 * Display label for a hook's file path: virtual rows (e.g.
 * `vscode-settings://kirin.hooks`) get a friendly label, real workspace paths
 * get backslash→slash normalization. Single source of truth shared by the
 * File cell, the File column sort accessor (`columns.tsx`), and the detail
 * drawer (`HookDetailModal`) so the displayed and sorted values can't drift
 * for virtual paths (Bugbot KIR-2917).
 */
export function getHookFileDisplayLabel(filePath: string): string {
  return getVirtualPathDetails(filePath)
    ? getFilePathDisplayLabel(filePath)
    : normalizePathForDisplay(filePath);
}
